<template>
  <div class="chart-box container">
    <el-row :gutter="20">
      <el-col :span="6" class="results-left">
        <el-card class="box-card department-card">
          <div slot="header" class="clearfix">
            <span>推荐阅读</span>
          </div>
          <div
            :span="12"
            v-for="(item, index) in newsList"
            :key="index"
            class="item text"
          >
            <p style="cursor: pointer" @click="check(item)">
              {{ index + 1 }}.{{ item.titleCN }}
            </p>
          </div>
        </el-card>
      </el-col>
      <el-col :span="18">
        <el-row class="type-opr">
          <el-col :span="24" style="text-align: right">
            <el-button
              type="primary"
              size="medium"
              plain
              icon="el-icon-bottom"
              @click="checkAll"
              >查看全文</el-button
            >
          </el-col>
        </el-row>
        <el-card class="box-card" style="margin-top: 10px">
          <div slot="header" class="clearfix">
            <span>正文</span>
          </div>
          <div class="talent-info">
            <p>{{ abstractCN }}</p>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "index",
  data() {
    return {
      link: "",
      abstractCN: "",
      newsList: [],
    };
  },
  methods: {
    // 获取新冠肺炎
    getSearchAllInfo() {
      let that = this;
      this.$axios({
        method: "get",
        url: "/api/covidFind?key=COVID-19&size=8",
      })
        .then(function (res) {
          that.newsList = res.data.data.slice(0, 8);
        })
        .catch(function (thrown) {});
    },
    // 查看详情
    check(item) {
      this.abstractCN = item.abstractCN;
      this.link = item.link;
      sessionStorage.abstractCN = item.abstractCN;
      sessionStorage.link = item.link;
      window.scrollTo(0, 0);
    },
    // 查看全文
    checkAll() {
      window.open(this.link, "_blank");
    },
  },
  mounted() {
    if (this.$route.params.abstractCN) {
      sessionStorage.abstractCN = this.$route.params.abstractCN;
      sessionStorage.link = this.$route.params.link;
    }

    this.abstractCN = sessionStorage.abstractCN;
    this.link = sessionStorage.link;
    this.getSearchAllInfo();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/newDetail.vue